import styled from 'styled-components';

import { ButtonWithLoader } from '../../../components/ui-helpers';
import { AvatarImage } from '../../../components/avatar/styled-components';

export const TaskWrap = styled.div`
  margin-top: 18px;

  .ql-editor {
    overflow-y: hidden;
  }
`;

export const TaskDueDate = styled.span`
  color: #E84747;
`;

export const Title = styled.span`
  font-size: 13px;
  font-weight: normal;
  color: #A4A4A4;
  margin-right: 13px;
  width: 75px;
`;

export const JustText = styled.span`
  color: #1B1B1B;
  font-size: 13px;
  line-height: 21px;
`;

export const ButtonWrap = styled.div`
  margin-top: 20px;
  text-align: center;

  ${ButtonWithLoader} {
    height: 40px;
    max-width: 160px;
    border-radius: 30px;
  }
`;

export const UserAvatar = styled(AvatarImage)`
  margin-right: 13px;
  border: none;
`;

export const ListBox = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 8px;
`;



// WEBPACK FOOTER //
// ./src/modals/tasks-modal/task-details/styles.js